import React, { useState } from 'react';
import {
  DumbSelectionGroup,
  Checkbox,
  Radio,
  Link,
  Tabs,
  Tab,
  TabPanel,
  Dropdown,
  BasicModalWithFooter,
  PrimaryButton,
} from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-internal/js-react-i18n';

import { MILEAGE_OPTIONS, MAX_L2_FILTERS } from '../constants';

const mileageOptions = MILEAGE_OPTIONS as any;
import Classes from './SearchFeed.module.scss';

type TFilterModalProps = {
  currentFilterId: string | number | null;
  filterOptions: any[];
  searchCategories: any;
  modelFilter: Record<string, any>;
  priceFilter: number | null;
  mileageFilter: [number | null, number | null];
  l1Filters: any[];
  l2Filters: any[];
  appliedFilters: any[];
  onFilter: (option: any, type: string) => void;
  onClose: () => void;
  filterValuesRef: React.RefObject<HTMLDivElement | null>;
};

const FilterModal = ({
  currentFilterId,
  filterOptions,
  searchCategories,
  modelFilter,
  priceFilter,
  mileageFilter,
  l1Filters,
  l2Filters,
  appliedFilters,
  onFilter,
  onClose,
  filterValuesRef,
}: TFilterModalProps) => {
  const { t, tExists } = useI18nContext();
  const [activeTab, setActiveTab] = useState(0);
  const [showMoreFilterOptions, setShowMoreFilterOptions] = useState(false);

  const getTitle = () => {
    if (tExists(`toys.filters.modal.${currentFilterId}.title`)) {
      return t(`toys.filters.modal.${currentFilterId}.title`);
    }
    return searchCategories?.l1Categories?.find(({ value }) => Number(value) === currentFilterId)?.labelText;
  };

  return (
    <BasicModalWithFooter
      isBottomSheet
      size="m"
      title={getTitle()}
      onClose={onClose}
      buttons={[
        {
          element: <PrimaryButton onClick={onClose}>{t('searchfeed.filters.show')}</PrimaryButton>,
        },
      ]}
    >
      <div ref={filterValuesRef}>
        {currentFilterId === 'model' && (
          <>
            <Tabs className={Classes.modelTabs} activeTab={activeTab} setActiveTab={setActiveTab} isFluid>
              {Object.keys(modelFilter).map((modelForBrand, index) => (
                <Tab key={index} label={modelForBrand} />
              ))}
            </Tabs>
            {Object.keys(modelFilter).map((modelForBrand, index) => (
              <TabPanel className={Classes.modelTabPanel} activeTab={activeTab} tab={index} key={index}>
                <DumbSelectionGroup>
                  {modelFilter[modelForBrand].options.map((option) => (
                    <Checkbox
                      id={option.id}
                      key={option.value}
                      value={option.value}
                      onChange={() => onFilter(option, 'filter')}
                      isChecked={appliedFilters.includes(option.id)}
                      labelText={option.labelText}
                    />
                  ))}
                </DumbSelectionGroup>
              </TabPanel>
            ))}
          </>
        )}
        {currentFilterId !== 'model' && (
          <DumbSelectionGroup>
            {currentFilterId === 'price' &&
              filterOptions.map((option) => (
                <Radio
                  id={option.id}
                  key={option.value}
                  value={option.value}
                  onChange={() => onFilter(option, 'price')}
                  isChecked={priceFilter === option.value}
                  labelText={option.labelText}
                  icon={option.icon ? option.icon : null}
                />
              ))}
            {currentFilterId === 'mileage' && (
              <>
                <Dropdown
                  id="mileage-from"
                  labelText="Van"
                  options={
                    mileageFilter[1]
                      ? mileageOptions.filter(({ value }) => value < Number(mileageFilter[1]))
                      : mileageOptions
                  }
                  onChange={(e) => onFilter(e.target.value, 'mileageFrom')}
                  value={mileageFilter[0]?.toString()}
                />
                <Dropdown
                  id="mileage-to"
                  labelText="Tot"
                  options={
                    mileageFilter[0]
                      ? mileageOptions.filter(({ value }) => value > Number(mileageFilter[0]))
                      : mileageOptions
                  }
                  onChange={(e) => onFilter(e.target.value, 'mileageTo')}
                  value={mileageFilter[1]?.toString()}
                />
              </>
            )}
            {currentFilterId !== 'price' &&
              currentFilterId !== 'mileage' &&
              typeof currentFilterId === 'number' &&
              filterOptions.map((option) => (
                <Checkbox
                  id={option.id}
                  key={option.value}
                  value={option.value}
                  onChange={() => onFilter(option, 'category')}
                  isChecked={Boolean(
                    currentFilterId === 0
                      ? l1Filters.find(({ value }) => value === option.value)
                      : l2Filters.find(({ value }) => value === option.value),
                  )}
                  labelText={option.labelText}
                  icon={option.icon ? option.icon : null}
                />
              ))}
            {currentFilterId !== 'price' &&
              typeof currentFilterId !== 'number' &&
              currentFilterId !== 'model' &&
              currentFilterId !== 'mileage' &&
              filterOptions
                .filter(({ hidden }) => !hidden || showMoreFilterOptions)
                .map((option) => (
                  <Checkbox
                    id={option.id}
                    key={option.value}
                    value={option.value}
                    disabled={
                      !appliedFilters.includes(option.id) &&
                      currentFilterId === 'l2Category' &&
                      appliedFilters.filter((filter) => typeof filter === 'string' && filter.includes('cat-')).length >=
                        MAX_L2_FILTERS
                    }
                    onChange={() => onFilter(option, currentFilterId === 'l2Category' ? 'l2Category' : 'filter')}
                    isChecked={appliedFilters.includes(option.id)}
                    labelText={option.labelText}
                  />
                ))}
            {currentFilterId === 'options' && (
              <Link onClick={() => setShowMoreFilterOptions(!showMoreFilterOptions)} className={Classes.showMoreLink}>
                {showMoreFilterOptions ? 'Toon minder...' : 'Toon meer...'}
              </Link>
            )}
          </DumbSelectionGroup>
        )}
      </div>
    </BasicModalWithFooter>
  );
};

export default FilterModal;
